import React, { Component } from 'react';
import { Tabs } from 'antd';
import dayjs from 'dayjs'
import './App.css';
import banner from "./img/banner.png"
import advantage from "./advantage@3x.png"
import mission from "./mission@3x.png"
import object from "./object@3x.png"
import staff from "./img_rlzy.png"
import cpzx from "./img_cpzx@3x.png"
import LOGO from './img/logo.png'

import imgContacts1 from './img/contacts/contacts1.png'
import imgContacts2 from './img/contacts/contacts2.png'
import imgContacts3 from './img/contacts/contacts3.png'

import imgOthers1 from './img/others/others1.png'
import imgOthers2 from './img/others/others2.png'
import imgOthers3 from './img/others/others3.png'
import imgOthers4 from './img/others/others4.png'



import FOOTER from './img/footer2.jpg'
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      type: "contacts"
    }
  }

  componentDidMount() {

  }

  viewPdf = (_url) => {
    window.open(_url)
  }

  tabChange = (value) => {
    window.location.href = window.location.origin + value
  }

  tabChange1 = (value) => {
    this.setState({
      type: value
    })
  }
  onDocumentComplete(pages) {
    this.setState({ page: 1, pages: pages });
  }
  onChange(page) {
    this.setState({
      page: page,
    });
  }
  render() {
    return (
      <div className="App">
        <div className="center">
          <div className="topNav">
            <div style={{ width: 1440, margin: "auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <img style={{ width: '100px' }} src={LOGO} alt="" />
              </div>
              <Tabs defaultActiveKey="1" tabBarGutter={60} onChange={this.tabChange}>
                <Tabs.TabPane tab="关于我们" key="#banner"></Tabs.TabPane>
                <Tabs.TabPane tab="产品信息展示中心" key="#product"></Tabs.TabPane>
                <Tabs.TabPane tab="人力资源" key="#staff"></Tabs.TabPane>
                {/* <Tabs.TabPane tab="行业及产品资讯" key="#news"></Tabs.TabPane> */}
                <Tabs.TabPane tab="联系我们" key="#us"></Tabs.TabPane>
              </Tabs>
            </div>
          </div>
          <div id="banner" className="banner">
            <img src={banner} alt="" />
          </div>
          <div id="advantage" className="advantage">
            <img src={advantage} alt="" />
          </div>
          <div id="mission" className="mission">
            <img src={mission} alt="" />
          </div>
          <div id="object" className="advantage object">
            <img src={object} alt="" />
          </div>
          <div id="product" className="product">
            <div className="wrap">
              <div className="title" style={{ width: "477px", height: 142, marginBottom: 30, position: "relative" }}>
                <span style={{ position: "absolute", top: "22px", left: "18%", fontSize: 38, color: "#0060c4", fontWeight: "bold" }}>产品信息展示中心</span>
                <img src={cpzx} alt="" />
              </div>
              <div >
                <div style={{display: 'flex', justifyContent: 'center'}}>
                  <Tabs defaultActiveKey="contacts" tabBarGutter={60} onChange={this.tabChange1}>
                    <Tabs.TabPane tab={<span style={{ fontSize: 20 }}>彩色隐形眼镜</span>} key="contacts"></Tabs.TabPane>
                    <Tabs.TabPane tab={<span style={{ fontSize: 20 }}>周边产品</span>} key="others"></Tabs.TabPane>
                  </Tabs>
                </div>
              </div>
              <div style={{ width: "1250px", margin: "auto", height: 500, marginTop: 32 }}>
                <ul style={{ display: "flex", justifyContent: "space-around" }}>
                  {
                    this.state.type === "contacts" ? (
                      <>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={imgContacts1} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            iNYX小银盒系列水凝胶彩色隐形眼镜日抛10片装
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={imgContacts2} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            iNYX小银盒女神系列半年抛彩色隐形眼镜1片装
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={imgContacts3} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            iNYX小银盒日抛水凝胶彩色隐形眼镜日抛2片装
                          </div>
                        </li>
                      </>
                    ) : null
                  }
                  {
                    this.state.type === "others" ? (
                      <>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={imgOthers1} alt="" style={{ width: 188, height: 188, objectFit: 'contain' }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            iNYX隐形眼镜伴侣盒
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={imgOthers2} alt="" style={{ width: 188, height: 188, objectFit: 'contain' }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            iNYX隐形眼镜护理液
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={imgOthers3} alt="" style={{ width: 188, height: 188, objectFit: 'contain' }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            iNYX折叠化妆镜
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={imgOthers4} alt="" style={{ width: 188, height: 188, objectFit: 'contain' }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            iNYX石膏香片
                          </div>
                        </li>
                      </>
                    ) : null
                  }
                </ul>
              </div>
            </div>
          </div>
          <div id="staff" className="staff" >
            <img src={staff} alt="" />
            {/*
            <div className="title" style={{ width: "477px", height: 142, marginBottom: 30, position: "relative", paddingTop: 36 }}>
              <div style={{color: "#0060c4", textAlign: 'center', fontWeight: "bold"}}>
                <dic style={{ fontSize: 38, color: "#0060c4", fontFamily: 'sans-serif'}}>人力资源</dic>
                <div style={{color: "rgba(0,96,196,0.3)", fontSize: 24, }}>Human Resource</div>
              </div>
            </div>
            <div
              style={{
                background: '#fff',
                width: 960,
                display: 'flex',
                margin: '0 auto',
                textAlign: 'left',
                fontSize: 14,
                lineHeight: 1.75,
                color: '#999',
                borderRadius: 12,
              }}
            >
              <div style={{flex: 1, boxSizing: 'border-box', padding: 36, }}>
                <div style={{fontWeight: 'bold', color: '#0060c4', marginBottom: 12, fontSize: 18}}>新媒体推广</div>
                <div style={{whiteSpace: 'pre-wrap'}}>
                  岗位职责:<br/>
                  1、根据品牌预算，协助完成月度媒介投放策略和计划执行：包括沟通协调投放渠道的KOL合作，排期规划执行、KOL关系维护等，投放渠道主要为抖音平台。<br/>
                  2、根据推广需求筛选KOL沟通合作，实时推进项目推广进度，根据实际情况调整投放计划。<br/>
                  3、把控和谈判媒介合作成本价，对费用具备把控能力。<br/>
                  4、建立公司自媒体及达人的合作资源库，同时了解达人生态和价值，能够结合达人特性推进合作工作。<br/>
                  5、负责客情维护工作，与媒体或达人建立良好合作关系，开拓和发展新的媒体关系。<br/>
                </div>
              </div>
              <div style={{flex: 1, boxSizing: 'border-box', padding: 36}}>
                <div style={{fontWeight: 'bold', color: '#0060c4', marginBottom: 12, fontSize: 18}}>市场策划</div>
                <div style={{whiteSpace: 'pre-wrap'}}>
                  岗位职责：<br/>
                  1、市场洞察及消费者需求结果的分析，从报告中洞察和分析出对品牌发展有益的结论，为品牌策略提供方向支持。<br/>
                  2、制定品牌定位、品牌故事和品牌核心价值观，细化品牌定位及内容，明确品牌在市场中的定位及差异化优势。<br/>
                  3、制定品牌传播的整体策略，以提升品牌知名度和认可度。<br/>
                  4、品牌建设流程机制完善与实行。<br/>
                  5、管理品牌形象和视觉识别系统，确保品牌在各个渠道和媒体上的一致性呈现。<br/>
                  6、监测品牌市场投放效果，进行分析和评估，发现问题及时与市场侧协调解决。<br/>
                </div>
              </div>
            </div>
            <div style={{height: 42}} />
            */}
          </div>
          <div id="us" className="us" style={{ position: "relative", }}>
            <div>
              <img src={FOOTER} alt="" />
              {/* <span style={{ fontSize: 16, position: "absolute", top: "88%", left: "40%", color: "#fff" }}>互联网药品信息服务资格证书编号：</span> */}

              <div className='zs' style={{ position: "absolute", width: '100%', top: "88%",  color: '#fff', fontSize: '16px', textAlign: 'center' }} >
                <a href="https://beian.miit.gov.cn/" target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >备案号：沪ICP备2021013322号-6</a>
                {/*<div>
                  <a href={ZS1} className='zs_code' target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >
                    互联网药品信息服务资格证书编号：（沪）-非经营性-2021-0165
                  </a>
                </div>
                <a href={ZS2} target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >医疗器械经营许可证：沪宝食药监械经营许20180053号</a>
                &nbsp;|&nbsp;
                <a href={ZS3} target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >医疗器械网络销售备案信息</a>
                &nbsp;|&nbsp;
                <a href={ZS4} target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >经营者信息</a>*/}
                <div>
                  <a href={`https://s1.vsigo.cn/lm/cert/medical-device-business-license.png?t=${dayjs().format('YYYYMMDD')}`} target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >医疗器械经营许可证：沪宝药监械经营许20180053号</a>
                  &nbsp;|&nbsp;
                  <a href={`https://s1.vsigo.cn/lm/cert/internet-sales-registration.jpg?t=${dayjs().format('YYYYMMDD')}`} target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >医疗器械网络销售备案信息</a>
                  &nbsp;|&nbsp;
                  <a href={`https://s1.vsigo.cn/lm/cert/business-license.jpg?t=${dayjs().format('YYYYMMDD')}`} target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >经营者信息</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
